// src/resources/comtrue/js/default/ocr_variables.js
import React, { createContext, useContext, useState } from 'react'

// 초기 상태값 정의
const initialState = {
    videoComtrue: null,
    canvasComtrue: null,
    contextPathComtrue: process.env.REACT_APP_API_AUTH,
    requestEncryptPublicKeyComtrue: null,
    responseDecryptPrivateKeyComtrue: null,
    cardTypeVarComtrue: '',
    tokenComtrue: null,
    getModifiedTextComtrue: true,
    ekycModeComtrue: false,
    debugModeComtrue: process.env.REACT_APP_DEBUG_MODE === 'true',
    idNumberMasking: process.env.REACT_APP_ID_NUMBER_MASKING === 'true',
    ocrLiveness: true,
    encryptView: process.env.REACT_APP_ENCRYPT_VIEW === 'true',
    useWebSocket: process.env.REACT_APP_USE_WEBSOCKET === 'true',
    ws: null,
    CLOSE_FAKE_CNT_COMTRUE: 4,
    MAX_FAKE_CNT_COMTRUE: 0,
    MAX_BLUR_CNT_COMTRUE: 0,
    MAX_OCR_NOT_FINISH_CNT_COMTRUE: 6,
    MAX_CAPTURE_FAIL_CNT: 2,
    MAX_CAPTURE_CNT: 2,
    errorCount: 0,
    realCount: 0,
    fakeCount: 0,
    blurCount: 0,
    ocrNotFinishCount: 0,
    captureFailCount: 0,
    captureSuccessCnt: 0,
    returnFileVarComtrue: 'false',
    returnFaceVarComtrue: 'true',
    BOX_CONTAINER_ROWS_TOP_RATIO: 1,
    BOX_CONTAINER_ROWS_BOTTOM_RATIO: 1,
    BOX_CONTAINER_COLUMNS_TOP_RATIO: 1,
    BOX_CONTAINER_COLUMNS_BOTTOM_RATIO: 1,
    checkOcrField: true,
    checkVisibilityState: 'visible',
    checkVisibilityStateVisible: true,
    comtrueCustomVideoResolution: null,
    modifiedInputColor: null,
    CALL_BACK_FUNC: '',
    additionalModifiedField: false,
    excludeOcrFields: [],

    // [2025.06.09] 키 추가
    licenseKey: '',
    initTime: 0,
    rsaKeys: '',

    // [2025.06.10] 콜백 관련 변수 추가
    resData: '',
    captureCount: 0,
    blurScore: 0,

    // [2025.06.10] ref 관련 변수 추가
    rectangleEdgeRefsComtrue: [],
    bottomTextRefComtrue: null,

    boxTopRefComtrue: null,
    boxContainerRefComtrue: null,
    rectangleCursorRefComtrue: null,
    resultFormGroupRefComtrue: null,
    modalContentRefComtrue: null,
    comment2RefsComtrue: [],
    guideMessageTextRefComtrue: null,

    // [25.07.02] 인터벌 관련 변수 추가
    ocrCaptureCount: 0,

    // 최대 촬영 횟수
    OCR_MAX_CNT: 30,
    // 초기 카메라 딜레이
    OCR_INIT_DELAY: 500,
    // 카메라 딜레이
    OCR_INTERVAL: 250,

    // [26.01.23] 해상도 정보 추가
    COM_WIDTH : 0,
    COM_HEIGHT : 0,
    // [26.01.23] 검은 화면 감지시 플래그
    blackScreenRetryFlag : '',
}

// COMTRUEVAR 객체 생성 및 export
export const COMTRUEVAR = { ...initialState }

// Context 및 Provider 구현
const ComtrueContext = createContext()

export const ComtrueProvider = ({ children }) => {
    const [state, setState] = useState(initialState)

    // state가 변경될 때마다 COMTRUEVAR 업데이트
    React.useEffect(() => {
        Object.assign(COMTRUEVAR, state)
    }, [state])

    const updateState = (updates) => {
        setState((prev) => {
            const newState = { ...prev, ...updates }
            Object.assign(COMTRUEVAR, newState)
            return newState
        })
    }

    const incrementCounter = (counterName) => {
        setState((prev) => {
            const newState = {
                ...prev,
                [counterName]: prev[counterName] + 1,
            }
            Object.assign(COMTRUEVAR, newState)
            return newState
        })
    }

    const resetCounters = () => {
        setState((prev) => {
            const newState = {
                ...prev,
                errorCount: 0,
                fakeCount: 0,
                blurCount: 0,
                captureFailCount: 0,
                captureSuccessCnt: 0,
                ocrNotFinishCount: 0,
            }
            Object.assign(COMTRUEVAR, newState)
            return newState
        })
    }

    const value = {
        ...state,
        updateState,
        incrementCounter,
        resetCounters,
    }

    return (
        <ComtrueContext.Provider value={value}>
            {children}
        </ComtrueContext.Provider>
    )
}

export const useComtrue = () => {
    const context = useContext(ComtrueContext)
    if (!context) {
        throw new Error('useComtrue must be used within ComtrueProvider')
    }
    return context
}
